import { isUndefined } from 'lodash';

export const composeConfig = (options = []) => {
    const { value } = options.find(o => o.isDefault) || {};

    return {
        options,
        defaultValue: isUndefined(value) ? null : value
    };
};


export const SIRE_TYPE = composeConfig([
    {
        label: 'All',
        value: 'all',
        isDefault: true
    },
    {
        label: 'First Crop',
        value: 'firstCrop'
    },
    {
        label: 'Second Crop',
        value: 'secondCrop'
    },
    {
        label: 'Third Crop',
        value: 'thirdCrop'
    }
]);

export const WIN_DIST = composeConfig([
    {
        label: 'All',
        value: '',
        isDefault: true
    },
    {
        label: '5f',
        value: '5f'
    },
    {
        label: '6f',
        value: '6f'
    },
    {
        label: '7f',
        value: '7f'
    },
    {
        label: '1 mile',
        value: '1m'
    },
    {
        label: '1m - 1m1f',
        value: '1m-1m1f'
    },
    {
        label: '1m2f - 1m3f',
        value: '1m2f-1m3f'
    },
    {
        label: '1m4f - 1m5f',
        value: '1m4f-1m5f'
    },
    {
        label: '1m6f - 1m7f',
        value: '1m6f-1m7f'
    },
    {
        label: '2m - plus',
        value: '2m-null'
    }
]);

const yearsList = [
    {
        label: 'All',
        value: '',
        isDefault: true
    }
];

for (let y = new Date().getFullYear(); y >= 1988; y--) {
    yearsList.push({ label: `${y}`, value: `${y}` });
}

export const YEAR_TO_STUD = composeConfig(yearsList);

export const STUD_FEE = composeConfig([
    {
        label: 'All',
        value: '/',
        isDefault: true
    },
    {
        label: '£5,000 and under',
        value: '0/5000'
    },
    {
        label: '£5,001 - £10,000',
        value: '5001/10000'
    },
    {
        label: '£10,001 - £20,000',
        value: '10001/20000'
    },
    {
        label: '£20,001 - £50,000',
        value: '20001/50000'
    },
    {
        label: '£50,000+',
        value: '50000/'
    }
]);

export const COUNTRY = composeConfig([
    {
        label: 'GB and IRE',
        value: 'GB,IRE'
    },
    {
        label: 'Great Britain',
        value: 'GB'
    },
    {
        label: 'Ireland',
        value: 'IRE'
    },
    {
        label: 'France',
        value: 'FR'
    },
    {
        label: 'GB, IRE and France',
        value: 'GB,IRE,FR'
    },
    {
        label: 'USA',
        value: 'USA'
    },
    {
        label: 'All',
        value: 'all',
        isDefault: true
    }
]);

export const PROGENY_SUCCESS = composeConfig([
    {
        isSelected: false,
        label: 'Turf winners',
        value: 'turfWinners'
    },
    {
        isSelected: false,
        label: 'Hurdle winners',
        value: 'hurdleWinners'
    },
    {
        isSelected: false,
        label: 'Chase winners',
        value: 'chaseWinners'
    },
    {
        isSelected: false,
        label: 'AW winners',
        value: 'allWeatherWinners'
    },
    {
        isSelected: false,
        label: 'G1 winners',
        value: 'g1Winner'
    },
    {
        isSelected: false,
        label: 'G2 winners',
        value: 'g2Winner'
    },
    {
        isSelected: false,
        label: 'G3 winners',
        value: 'g3Winner'
    },
    {
        isSelected: false,
        label: 'Grade winners',
        value: 'gradeWinners'
    },
    {
        isSelected: false,
        label: 'Black-type winners',
        value: 'blackTypeWinners'
    }
]);

export const STUD_FARM = composeConfig();
export const STALLION = composeConfig();
export const SIRE = composeConfig();
export const SIRE_LINE = composeConfig();



// WEBPACK FOOTER //
// ./src/client/optionSets/options.js